import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { hmrBootstrap } from 'hmr';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

export interface Env {
    apiUrl: string;
    coreApiUrl: string;
    jobsWorkerApiUrl: string;
    devApi: boolean;
    authUrl: string;
}

const time = new Date().getTime();

fetch(`assets/env.json?t=${time}`)
    .then(res => res.json())
    .then((resp: Env) => {
        console.warn('env.json loaded', resp);
        environment.devApi = resp.devApi;
        environment.jobsWorkerApiUrl = resp.jobsWorkerApiUrl;
        environment.coreApiUrl = resp.coreApiUrl;
        environment.authUrl = resp.authUrl;
    })
    .catch(() => console.warn('env.json not loaded...'))
    .finally(() => {
        const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

        if (environment.hmr) {
            if (module['hot']) {
                hmrBootstrap(module, bootstrap);
            } else {
                console.error('HMR is not enabled for webpack-dev-server!');
                console.log('Are you using the --hmr flag for ng serve?');
            }
        } else {
            bootstrap().catch(err => console.log(err));
        }
    });
